export default __webpack_public_path__ + "static/media/ayan-banner.1f8a9e83.png";